export default __webpack_public_path__ + "img/contract-design.797601c2.jpg";